import { isFulfilled, isPending, isRejected } from "../../utils/redux/action-utils.js";
import { onFulfilled, onPending, onRejected } from "../../utils/redux/state-utils.js";
import { modalViewInitialState } from "./initial-state.js";
//#region src/redux/modal-view/extra-reducers.ts
var isActionFulfilled = (action) => isFulfilled(action, "modal-view");
var isActionPending = (action) => isPending(action, "modal-view");
var isActionRejected = (action) => isRejected(action, "modal-view");
var isSignOut = (action) => isFulfilled(action, "auth/signOut");
var onSignOut = (state) => {
	state.modalViews = modalViewInitialState.modalViews;
	state.isPending = modalViewInitialState.isPending;
	state.isRejected = modalViewInitialState.isRejected;
	state.errorMessage = modalViewInitialState.errorMessage;
};
var extraReducers = (builder) => {
	builder.addMatcher(isActionFulfilled, onFulfilled).addMatcher(isActionPending, onPending).addMatcher(isActionRejected, onRejected).addMatcher(isSignOut, onSignOut);
};
//#endregion
export { extraReducers };

//# sourceMappingURL=extra-reducers.js.map